import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { PatientBannerService } from '../patient-banner/patient-banner.service';
import { SchedularServiceService } from '../Services/Schedular/schedular-service.service';

@Component({
  selector: 'app-videocalling-div',
  templateUrl: './videocalling-div.component.html',
  styleUrls: ['./videocalling-div.component.css']
})
export class VideocallingDivComponent implements OnInit {
  restoredownVideodiv = false;
  maximizeVideodiv = true;
  closeVideo = false;
  public qna_private_url;

  public messageClasses: string = "restoredown";
  linkurl: any;

  // public restoredown = true;
  // public maximize = false;
  // public minimize = false;
  // public messageClasses = {
  //   "restoredown": this.restoredown,
  //   "maximize": this.maximize,
  //   "minimize": this.minimize
  // }

  constructor(private bannerService: PatientBannerService, private sanitizer: DomSanitizer
    , private schedulerService: SchedularServiceService,) { }

  ngOnInit() {

    this.bannerService.videocallShow.subscribe(urllink => {

      this.closeVideo = true;
      this.linkurl = this.sanitizer.bypassSecurityTrustResourceUrl(urllink);
      // setTimeout(() => {
      //   
      //   let iframe = document.querySelectorAll('iframe')[0];
      //   iframe.forEach(item =>
      //   )
      // });

    }, 1000);

    this.bannerService.videotoggelShow.subscribe(isvideohide => {
      alert(isvideohide)
    })
  }
  minimizeVideo() {
    // alert('minimizeVideo')
    this.messageClasses = 'minimize';

    this.restoredownVideodiv = true;
    this.maximizeVideodiv = false;
  }
  restoredownVideo() {
    //  alert('restoredownVideo')

    this.restoredownVideodiv = false;
    this.maximizeVideodiv = true;
    this.messageClasses = 'restoredown';
  }

  maximizeVideo() {
    //  alert('maximizeVideo')

    this.restoredownVideodiv = true;
    this.maximizeVideodiv = false;
    this.messageClasses = 'maximize';
  }
  IsRoomFull: any = false;
  closeVideoFun(event) {
    if (sessionStorage.getItem("IsRoomFull") != undefined && sessionStorage.getItem("IsRoomFull") != null) {
      this.IsRoomFull = sessionStorage.getItem("IsRoomFull");
      this.IsRoomFull = (/true/i).test(this.IsRoomFull);
    }
    if (this.IsRoomFull == false) {
      this.closeVideo = false;
      this.linkurl = null;
      let appointmentId = sessionStorage.getItem("appId");
      this.schedulerService.CallStatus(3, false, appointmentId, 'checkout').subscribe(
        (callstatus: number) => {
          sessionStorage.removeItem("appId");
          localStorage.removeItem("CloseType");
          this.bannerService.getAppointments(true);
        },
        (err: any) => {
          console.log(err);
          sessionStorage.removeItem("appId");
          localStorage.removeItem("CloseType");
        });
    } else {
      this.closeVideo = false;
      this.linkurl = null;
      sessionStorage.removeItem("IsRoomFull");
    }
  }

  closeVideoFun1(event) {
    let text = "Are you sure you want to close this video?.";
    if (window.confirm(text) == true) {
      this.closeVideo = false;
      this.linkurl = null;
      let appointmentId = sessionStorage.getItem("appId");
      this.schedulerService.CallStatus(3, false, appointmentId, 'checkout').subscribe(
        (callstatus: number) => {
          sessionStorage.removeItem("appId");
          localStorage.removeItem("CloseType");
          this.bannerService.getAppointments(true);
        },
        (err: any) => {
          console.log(err);
          sessionStorage.removeItem("appId");
          localStorage.removeItem("CloseType");
        });
    }
  }
}
